import { Component, Inject, OnInit } from "@angular/core";
import {
  MatSnackBar,
  MatSnackBarRef,
  SimpleSnackBar,
  MAT_SNACK_BAR_DATA,
} from "@angular/material/snack-bar";
import { MyUtils } from "src/app/services/my-utils.service";

@Component({
  selector: "app-snackbar",
  templateUrl: "./snackbar.component.html",
  styleUrls: ["./snackbar.component.css"],
})
export class SnackbarComponent implements OnInit {
  ngOnInit(): void {}
  constructor(public snackBarRef: MatSnackBarRef<SnackbarComponent> , public utils: MyUtils) {}
}
